import React from 'react';

export default function BatteryResult({ allFeelings, feeling, clicked }) {
  return (
    <div className="b-container sm:!mt-2">
      <div className="fc-c">
        <div className="fc-h"></div>
        <div
          className="fc-m !w-auto !h-auto"
          style={{ borderColor: '#e4f2f4' }}
        >
          {allFeelings?.map((service) => (
            <div
              style={{
                backgroundColor:
                  clicked &&
                  feeling?.toLowerCase() === service.name?.toLowerCase()
                    ? service.color
                    : clicked && feeling !== service.name
                    ? 'gray'
                    : !clicked && feeling !== service.name && service.color,
                color:
                  service.name === 'Ok' && feeling !== 'Ok' ? '#ffff' : '#ffff',
              }}
              key={service?.id}
              className="px-4 py-1 text-center"
            >
              {service?.name}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
